import { FabricObject } from "./FabricObject";
export class FabricLine extends FabricObject {
    constructor(coords, args) {
        super(args);
        this.coords = coords;
        const keys = Object.keys(args);
        keys.forEach((key) => this[key] = args[key]);
    }
}
//# sourceMappingURL=FabricLine.js.map